export const headerMenus = [

    // {
    //     item: "Medgate App",
    //     link: "/shop",
    //     name: "Shop",
    //     active: false
    // },

    {
        item: "Media",
        link: "https://medgate.ph/media/",
        name: "Shop",
        active: false,
        redirect: true
    },


    {
        item: "Shop",
        link: "https://shop.medgate.ph/",
        name: "Shop",
        active: false,
        redirect: true
    },

    {
        item: "Business",
        link: "https://medgate.ph/business/",
        name: "Shop",
        active: false,
        redirect: true
    },

    {
        item: "Jobs",
        link: "https://medgate.ph/jobs/",
        name: "Shop",
        active: false,
        redirect: true
    },

    {
        item: "FAQs",
        link: "https://medgate.ph/faqs/",
        name: "Shop",
        active: false,
        redirect: true
    },

    {
        item: "About",
        link: "https://medgate.ph/about/",
        name: "Shop",
        active: false,
        redirect: true
    },

    {
        item: "Contact Us",
        link: "https://medgate.ph/contactus/",
        name: "Contact Us",
        active: false,
        redirect: true
    },

    // {
    // 	item: "Medgate App",
    // 	link: "/medgate-app",
    // 	name: "MedgateApp",
    // 	active: false
    // },
    // {
    // 	item: "Media",
    // 	link: "/media",
    // 	name: "Media",
    // 	active: false
    // },
    // {
    // 	item: "Shop",
    // 	link: "/shop",
    // 	name: "Shop",
    // 	active: false
    // 	// link: [
    // 	//   {
    // 	//     subItem: "Shop Assignment",
    // 	//     subLink: "/shop/assignment"
    // 	//   },
    // 	//   {
    // 	//     subItem: "Shop Checkout",
    // 	//     subLink: "/shop/checkout"
    // 	//   }
    // 	// ]
    // },
    // {
    // 	item: "Business",
    // 	link: "/business",
    // 	name: "Business",
    // 	active: false
    // 	// link: [
    // 	//   {
    // 	//     subItem: "For Doctors",
    // 	//     subLink: "/"
    // 	//   },
    // 	//   {
    // 	//     subItem: "Job Vacancies",
    // 	//     subLink: "/"
    // 	//   }
    // 	// ]
    // },
    // {
    // 	item: "Jobs",
    // 	link: "/jobs",
    // 	name: "Jobs",
    // 	active: false
    // 	// link: [
    // 	//   {
    // 	//     subItem: "For Doctors",
    // 	//     subLink: "/"
    // 	//   },
    // 	//   {
    // 	//     subItem: "Job Vacancies",
    // 	//     subLink: "/"
    // 	//   }
    // 	// ]
    // },
    // {
    // 	item: "About",
    // 	link: "/about",
    // 	name: "About",
    // 	active: false
    // }
]

export const topHeaderMenus = [
    // {
    // 	item: "Member Login",
    // 	blueIcon: require("@/assets/images/login_icon.png"),
    // 	whiteIcon: require("@/assets/images/login_icon_white.png"),
    // 	link: "/login",
    // 	name: "Login",
    // 	active: false
    // },
    // {
    // 	item: "Contact Us",
    // 	blueIcon: require("@/assets/images/contact_icon.png"),
    // 	whiteIcon: require("@/assets/images/contact_icon_white.png"),
    // 	link: "/contact",
    // 	name: "Contact",
    // 	active: false
    // }
]

export const footerMenus = [
    {
        item: "About Medgate",
        link: "https://medgate.ph/about/"
    },
    {
        item: "Careers",
        link: "https://medgate.ph/jobs/"
    },
    {
        item: "Business",
        link: "https://medgate.ph/business/"
    },
    {
        item: "FAQs",
        link: "https://medgate.ph/faqs/"
    },
]

export const footerMedias = [
    {
        media: "facebook",
        link: "https://www.facebook.com/profile.php?id=61588083172637"
    },
    {
        media: "instagram",
        link: "https://www.instagram.com/medgatephilippines"
    },
    {
        media: "twitter",
        link: "https://twitter.com/MedgatePH"
    },
    {
        media: "youtube",
        link: "https://www.youtube.com/channel/UCXUY81i4niHSwMiOsse9LEw"
    },
    {
        media: "linkedin",
        link: "https://www.linkedin.com/company/medgate-philippines"
    },
]

export const footerOtherLinks = [
    {
        name: 'Media',
        link: 'https://medgate.ph/media'
    },
    {
        name: 'Code of Conduct',
        link: 'https://medgate.ph/medgate-code-of-conduct'
    },
    {
        name: 'Privacy Policy',
        link: 'https://medgate.ph/data-privacy-policy'
    },
    {
        name: 'Terms and Conditions Service',
        link: 'https://medgate.ph/terms-and-conditions'
    },
    {
        name: 'Terms and Conditions Shop',
        link: 'https://medgate.ph/terms-and-conditions-shop/'
    },
]
